module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_InformationCircle2_16"],"path":[{"$":{"d":"M8,1A7,7,0,1,1,1,8,7,7,0,0,1,8,1M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm2,12H9V6H6V7H7v5H6v1h4ZM9,3H7V5H9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_InformationCircle2_16.svg
// module id = mb5v
// module chunks = 1